// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dnd-pane {
  position: relative;
  display: flex;
  flex: 1 1 0%;
  height: 100%;
  width: 100%;
}
.dnd-pane__content {
  position: relative;
  display: flex;
  flex: 1 1 0%;
  height: 100%;
  width: 100%;
}
.dnd-pane__preview {
  position: absolute;
  left: 1px;
  right: 1px;
  bottom: 1px;
  top: 1px;
}
.dnd-pane__dragging-effect {
  pointer-events: none;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  background-color: var(--g-color-sfx-veil);
}
.dnd-pane__hover-effect {
  pointer-events: none;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  background-color: var(--g-color-base-selection);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DNDPane/DNDPane.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACJ;AACI;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACR;AAEI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;AAAR;AAGI;EACI,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,yCAAA;AADR;AAII;EACI,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,+CAAA;AAFR","sourcesContent":[".dnd-pane {\n  position: relative;\n  display: flex;\n  flex: 1 1 0%;\n  height: 100%;\n  width: 100%;\n}\n.dnd-pane__content {\n  position: relative;\n  display: flex;\n  flex: 1 1 0%;\n  height: 100%;\n  width: 100%;\n}\n.dnd-pane__preview {\n  position: absolute;\n  left: 1px;\n  right: 1px;\n  bottom: 1px;\n  top: 1px;\n}\n.dnd-pane__dragging-effect {\n  pointer-events: none;\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  top: 0px;\n  background-color: var(--g-color-sfx-veil);\n}\n.dnd-pane__hover-effect {\n  pointer-events: none;\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  top: 0px;\n  background-color: var(--g-color-base-selection);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
